import { Goal } from '@tamagui/lucide-icons';
import { useQueryClient } from '@tanstack/react-query';
import { Page } from '@unistocks/components/page/page';
import { toast } from '@unistocks/components/toast';
import { CreateSavingsGoalForm } from '@unistocks/features/savings-goals/components/forms/create-savings-goal-form';
import {
  savingsGoalsGetListQueryKey,
  useSavingsGoalsCreateMutation
} from '@unistocks/proxy/axios-client/SavingsGoalsQuery';
import { t } from '@unistocks/shared/localization/index.ts';
import { useRouter } from 'expo-router';

export const CreateSavingsGoal: React.FC = () => {
  const router = useRouter();
  const queryClient = useQueryClient();
  const { mutateAsync: onSubmit } = useSavingsGoalsCreateMutation({
    onSuccess: res => {
      toast.success(t('::SavingsGoalCreatedSuccessfully', { 0: res.name }));
      queryClient.invalidateQueries({
        queryKey: savingsGoalsGetListQueryKey()
      });
      router.navigate({ pathname: '/(tabs)/(menu)/savings-goals/[id]', params: { id: res.id } });
    }
  });

  return (
    <Page size="medium">
      <Page.ScrollView
        headerLogo={false}
        headerTitle={t('::Menu:SavingsGoals:Create')}
        breadcrumbs={[
          {
            key: 'savings-goals',
            rootPathName: '(menu)',
            name: t('::Menu:SavingsGoals'),
            href: '/(tabs)/(menu)/savings-goals',
            Icon: props => <Goal {...props} />
          }
        ]}
      >
        <Page.Content>
          <CreateSavingsGoalForm onSubmit={onSubmit} />
        </Page.Content>
      </Page.ScrollView>
    </Page>
  );
};
